import { useTranslation } from 'react-i18next'

import ScenarioSection from '../ScenarioSection/ScenarioSection'
import ScenarioItemCard from './ScenarioItemCard/ScenarioItemCard'

const OrderItemsScenario = ({ scenarioItems }) => {
  const { t } = useTranslation()

  return (
    <ScenarioSection
      title={t('Artículos del pedido')}
      emptyDescription={t('Añade artículos al pedido para ver el bloque en el layout.')}
      addLabel={t('Añadir artículo')}
      isEmpty={scenarioItems.entries.length === 0}
      onAdd={scenarioItems.add}
    >
      {scenarioItems.entries.map((item, index) => (
        <ScenarioItemCard
          key={item.id}
          item={item}
          position={index + 1}
          onChange={scenarioItems.update}
          onRemove={scenarioItems.remove}
        />
      ))}
    </ScenarioSection>
  )
}

export default OrderItemsScenario
